import React, { useState } from "react";
import styled from "styled-components";
import bg from "../../images/auth-bg.svg";
import signin from "../../images/signin.svg";
import lock from "../../images/lock.svg";
import { UseAuthContext } from "../../store/contexts/auth.context";
import { NavLink } from "react-router-dom";
import AuthWrapper from "./AuthWrapper";

function SignUp() {
  const [message, setmessage] = useState();
  const [errors, seterrors] = useState({
    email: null,
    password: null,
    nick: null,
  });
  const { signUp: AuthHandler } = UseAuthContext();
  const submitHandler = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;
    const nick = e.target.nick.value;
    if (!email.includes("@") || password.length < 5 || nick.lenght < 4) {
      return seterrors({
        email: !email.includes("@"),
        password: password.length < 5,
        nick: nick.length < 4 ? "required" : null,
      });
    }
    seterrors({ email: null, password: null, nick: null });
    const res = await AuthHandler(email, password, nick);
    setmessage(res.message);
  };
  return (
    <AuthWrapper bg={bg}>
      <main>
        <img src={signin} alt="" />
        <div>
          <img src={lock} alt="" />
          <h1>Sign In</h1>
          {message && <p style={{ color: "red" }}>{message}</p>}
          <form onSubmit={submitHandler}>
            <input
              type="text"
              name="nick"
              className={`${errors.nick ? "error" : ""} form-input`}
              placeholder="Nickname"
            />

            <input
              type="email"
              className={`${errors.email ? "error" : ""} form-input`}
              name="email"
              placeholder="Email Address"
            />

            <input
              type="password"
              name="password"
              className={`${errors.password ? "error" : ""} form-input`}
              placeholder="Password"
            />

            <input type="submit" value="SIGN IN" className="form-input" />
            <p>
              Alredy have a account? <br />
              <NavLink to={"/signin"}>Sign In Now!</NavLink>
            </p>
          </form>
        </div>
      </main>
    </AuthWrapper>
  );
}

export default SignUp;
